import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Navbar from './Navbar';
import Footer from './Footer';
import StoreSettingsPanel from './StoreSettingsPanel';

import { NotificationProvider, useNotification } from '../../context/NotificationContext';
import { GenericModalProvider } from '../../context/GenericModalContext';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';

import GenericModal from '../utils/GenericModal';

export const ShoppingCartIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

export const CloseIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const SettingsIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
  </svg>
);

export const TrashIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

export const PlusIcon = () => (
  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
  </svg>
);

export const MinusIcon = () => (
  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 12H6" />
  </svg>
);

export const WhatsAppIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-1.188-.593-2.21-1.542-2.902-2.657-.316-.55.316-.513.903-1.707.104-.25.052-.463-.074-.644-.173-.248-.734-1.766-.96-2.421-.242-.687-.486-.594-.67-.604-.173-.012-.371-.012-.57-.012-.198 0-.52.074-.793.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411"/>
  </svg>
);

export const LocationIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const Layout: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isCouponModalOpen, setIsCouponModalOpen] = useState(false);
  const [isDeliveryModalOpen, setIsDeliveryModalOpen] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [couponCode, setCouponCode] = useState('');
  const [isValidatingCoupon, setIsValidatingCoupon] = useState(false);
  const [cityName, setCityName] = useState('');
  const [districtName, setDistrictName] = useState('');
  const [countryCode, setCountryCode] = useState('20'); // كود مصر الافتراضي

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { cartItems, updateQuantity, removeItem, validateCoupon, currentCoupon, couponDiscount, removeCoupon } = useCart();
  const { user } = useAuth();
  const { notify } = useNotification();

  // ✅ Check if user is admin/manager/owner (not customer)
  const isAdminUser = !!user && user.role === 'super_admin';

  const togglePreview = () => setIsPreviewOpen(prev => !prev);
  const toggleSettings = () => setIsSettingsOpen(prev => !prev);
  const closeSettings = () => setIsSettingsOpen(false);
  const openCouponModal = () => setIsCouponModalOpen(true);
  const closeCouponModal = () => {
    setIsCouponModalOpen(false);
    setCouponCode('');
  };
  const openDeliveryModal = () => setIsDeliveryModalOpen(true);
  const closeDeliveryModal = () => {
    setIsDeliveryModalOpen(false);
    setCityName('');
    setDistrictName('');
  };

  // Calculate cart total items and total price
  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const cartSubtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  
  // Apply coupon discount if available
  const cartTotal = couponDiscount?.orderAfter || cartSubtotal;

  // Check if cart has items
  const hasCartItems = cartItems.length > 0;

  // Countdown timer effect
  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if (isRedirecting && countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            openWhatsAppDirectly();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isRedirecting, countdown]);

  // Handle quantity update
  const handleUpdateQuantity = (productId: number, branchId: number, quantity: number, colorId?: number) => {
    updateQuantity(productId, branchId, quantity, colorId);
    notify('success', t('cart.updateQuantitySuccess'));
  };

  // Handle item removal
  const handleRemoveItem = (productId: number, branchId: number, colorId?: number) => {
    removeItem(productId, branchId, colorId);
    notify('success', t('cart.removeItemSuccess'));
  };

  // Handle WhatsApp checkout - من الزر السريع
  const handleQuickWhatsAppCheckout = () => {
    if (currentCoupon) {
      // If coupon is already applied, ask for delivery info
      openDeliveryModal();
    } else {
      // Open coupon modal first
      openCouponModal();
    }
  };

  // Handle WhatsApp checkout - من داخل السلة
  const handleWhatsAppCheckout = async () => {
    if (currentCoupon) {
      // If coupon is already applied, ask for delivery info
      openDeliveryModal();
    } else {
      // Open coupon modal first
      openCouponModal();
    }
  };

  // Handle coupon validation
  const handleCouponValidation = async (code: string) => {
    if (!code.trim()) {
      notify('warning', t('cart.enterCouponCode'));
      return;
    }

    setIsValidatingCoupon(true);
    try {
      const result = await validateCoupon(code);
      if (result.success) {
        setCouponCode(code);
        notify('success', t('cart.couponApplied'));
        closeCouponModal();
        // Show success message with new total
        notify('info', `تم تطبيق الكوبون! الإجمالي الجديد: ${cartTotal.toFixed(2)} ج.م`, 3000);
        // Then ask for delivery info
        setTimeout(() => {
          openDeliveryModal();
        }, 1500);
      } else {
        notify('error', result.message || t('cart.couponInvalid'));
      }
    } catch (error) {
      notify('error', t('cart.couponValidationError'));
    } finally {
      setIsValidatingCoupon(false);
    }
  };

  // Start redirect countdown
  const startRedirectCountdown = () => {
    // Validate delivery info
    if (!cityName.trim()) {
      notify('warning', t('checkout.cityRequired'));
      return;
    }

    closeDeliveryModal();
    setIsRedirecting(true);
    setCountdown(5);
    
    // Show countdown notification
    notify('info', `سيتم فتح واتساب خلال ${countdown} ثواني...`, 5000);
  };

  // Open WhatsApp directly
  const openWhatsAppDirectly = () => {
    togglePreview();
    
    // Format cart items for WhatsApp message
    const itemsText = cartItems.map((item, index) => {
      const itemTotal = item.price * item.quantity;
      return `${index + 1}. ${item.name} × ${item.quantity} = ${itemTotal.toFixed(2)} ج.م`;
    }).join('\n');
    
    const totalText = `\n💰 المجموع الكلي: ${cartTotal.toFixed(2)} ج.م`;
    const couponText = currentCoupon ? `\n🎫 الكوبون: ${currentCoupon.code}` : '';
    
    // Format delivery info
    const deliveryText = districtName 
      ? `🏠 العنوان: ${cityName} - ${districtName}`
      : `🏠 المدينة: ${cityName}`;
    
    const message = `مرحباً، أريد إتمام الطلب التالي:\n\n🛒 المنتجات:\n${itemsText}${totalText}${couponText}\n\n${deliveryText}\n\n🔍 تم تأكيد الطلب من النظام مباشرة ✅`;
    
    const phoneNumber = `+201503323006`; // ✅ إضافة +20 لمصر
    const encodedMessage = encodeURIComponent(message);
    
    // Open WhatsApp with pre-filled message
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
    
    setIsRedirecting(false);
  };

  // Close cart preview when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      
      // Close cart preview if clicked outside
      if (isPreviewOpen && 
          !target.closest('.cart-preview') && 
          !target.closest('.cart-toggle')) {
        setIsPreviewOpen(false);
      }
    };

    if (isPreviewOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isPreviewOpen]);

  // Close with Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (isPreviewOpen) setIsPreviewOpen(false);
        if (isSettingsOpen) setIsSettingsOpen(false);
        if (isCouponModalOpen) setIsCouponModalOpen(false);
        if (isDeliveryModalOpen) setIsDeliveryModalOpen(false);
        if (isRedirecting) setIsRedirecting(false);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isPreviewOpen, isSettingsOpen, isCouponModalOpen, isDeliveryModalOpen, isRedirecting]);

  return (
    <NotificationProvider>
      <GenericModalProvider>
        <div className="flex flex-col min-h-screen bg-gradient-to-b from-gray-50 to-white">
          <Navbar onPreviewToggle={togglePreview} />

          {/* WhatsApp Quick Button - يظهر فقط إذا كان هناك منتجات في السلة */}
          {hasCartItems && (
            <motion.button
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0, opacity: 0 }}
              onClick={handleQuickWhatsAppCheckout}
              className="fixed right-6 bottom-40 z-30 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white p-5 rounded-full shadow-2xl transition-all duration-300 hover:shadow-3xl hover:scale-110 active:scale-95 group"
              aria-label={t('cart.whatsappOrder')}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="relative">
                <WhatsAppIcon />
                <span className="absolute -top-3 -right-3 bg-white text-green-600 text-xs font-bold px-2 py-1 rounded-full border border-green-200">
                  {cartCount}
                </span>
              </div>
              <span className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-green-600 text-white text-sm font-medium px-3 py-1 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg">
                {t('cart.whatsappOrder')}
              </span>
            </motion.button>
          )}

          {/* Admin Settings Button */}
          {isAdminUser && (
            <motion.button
              onClick={toggleSettings}
              className="settings-toggle fixed right-6 bottom-24 z-30 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white p-4 rounded-full shadow-xl transition-all duration-300 hover:shadow-2xl hover:scale-110 active:scale-95 group"
              aria-label={t('storeSettings.title')}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <SettingsIcon />
              <span className="absolute -top-2 -right-2 bg-white text-blue-600 text-xs font-bold px-2 py-1 rounded-full border border-blue-200">
                Admin
              </span>
            </motion.button>
          )}

          {/* Main Content */}
          <main className={twMerge('flex-grow relative', className)}>
            <div className="">
              {children}
            </div>
          </main>

          {/* Store Settings Panel */}
          {isAdminUser && (
            <StoreSettingsPanel
              isOpen={isSettingsOpen}
              onClose={closeSettings}
            />
          )}

          {/* Cart Preview Panel */}
          <AnimatePresence>
            {isPreviewOpen && (
              <>
                {/* Backdrop */}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="fixed inset-0 bg-black bg-opacity-50 z-40"
                  onClick={togglePreview}
                />

                {/* Cart Preview */}
                <motion.div
                  className="cart-preview fixed top-0 right-0 h-full w-full sm:w-96 bg-white shadow-2xl z-50 overflow-y-auto"
                  initial={{ x: '100%' }}
                  animate={{ x: 0 }}
                  exit={{ x: '100%' }}
                  transition={{ type: "spring", damping: 25, stiffness: 200 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="h-full flex flex-col">
                    {/* Header */}
                    <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 z-10">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900">
                            {t('cart.previewTitle', { defaultMessage: 'Your Cart' })}
                          </h2>
                          <p className="text-sm text-gray-500 mt-1">
                            {cartCount} {t('cart.items', { defaultMessage: 'items' })}
                          </p>
                        </div>
                        <button
                          onClick={togglePreview}
                          className="p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                          aria-label={t('cart.closePreview', { defaultMessage: 'Close cart' })}
                        >
                          <CloseIcon />
                        </button>
                      </div>
                    </div>

                    {/* Cart Items */}
                    <div className="flex-1 p-6 overflow-y-auto">
                      {!hasCartItems ? (
                        <div className="text-center py-12">
                          <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                            <ShoppingCartIcon />
                          </div>
                          <h3 className="text-lg font-semibold text-gray-700 mb-2">
                            {t('cart.emptyTitle', { defaultMessage: 'Your cart is empty' })}
                          </h3>
                          <p className="text-gray-500 mb-6">
                            {t('cart.emptyDescription', { defaultMessage: 'Add items to get started' })}
                          </p>
                          <button
                            onClick={() => {
                              togglePreview();
                              navigate('/products');
                            }}
                            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all duration-200"
                          >
                            {t('cart.shopNow', { defaultMessage: 'Shop Now' })}
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="mb-4 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-100 rounded-xl p-4">
                            <div className="flex items-center gap-2">
                              <div className="bg-green-100 p-2 rounded-full">
                                <ShoppingCartIcon />
                              </div>
                              <div>
                                <h3 className="font-semibold text-green-800">
                                  {t('cart.title')}
                                </h3>
                                <p className="text-sm text-green-600">
                                  {cartCount} {t('cart.items')} - {cartTotal.toFixed(2)} ج.م
                                </p>
                              </div>
                            </div>
                          </div>
                          
                          <div className="space-y-4">
                            {cartItems.map((item) => (
                              <motion.div
                                key={`${item.productId}-${item.branchId}-${item.colorId || 'no-color'}`}
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl hover:bg-white hover:shadow-sm transition-all duration-200 group"
                              >
                                <div className="relative">
                                  <img
                                    src={item.image || '/placeholder.png'}
                                    alt={item.name}
                                    className="w-20 h-20 object-cover rounded-lg shadow-sm"
                                  />
                                  {item.quantity > 1 && (
                                    <div className="absolute -top-2 -right-2 bg-blue-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                                      ×{item.quantity}
                                    </div>
                                  )}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <h3 className="font-semibold text-gray-900 truncate">
                                    {item.name}
                                  </h3>
                                  <p className="text-sm text-gray-600 mb-1">
                                    {item.branchProduct?.branch.name || 'No branch'}
                                  </p>
                                  {item.colorName && (
                                    <p className="text-xs text-gray-500 mb-1">
                                      {t('cart.color')}: {item.colorName}
                                    </p>
                                  )}
                                  <div className="flex items-center justify-between">
                                    <span className="font-bold text-blue-600">
                                      {item.price} ج.م
                                    </span>
                                    <span className="text-sm text-gray-500">
                                      {(item.price * item.quantity).toFixed(2)} ج.م
                                    </span>
                                  </div>
                                  
                                  {/* Quantity Controls */}
                                  <div className="flex items-center gap-2 mt-2">
                                    <button
                                      onClick={() => handleUpdateQuantity(
                                        item.productId,
                                        item.branchId,
                                        Math.max(1, item.quantity - 1),
                                        item.colorId
                                      )}
                                      className="p-1 bg-gray-200 hover:bg-gray-300 rounded-full"
                                    >
                                      <MinusIcon />
                                    </button>
                                    <span className="w-8 text-center font-medium">
                                      {item.quantity}
                                    </span>
                                    <button
                                      onClick={() => handleUpdateQuantity(
                                        item.productId,
                                        item.branchId,
                                        item.quantity + 1,
                                        item.colorId
                                      )}
                                      className="p-1 bg-gray-200 hover:bg-gray-300 rounded-full"
                                    >
                                      <PlusIcon />
                                    </button>
                                    
                                    {/* Remove Button */}
                                    <button
                                      onClick={() => handleRemoveItem(
                                        item.productId,
                                        item.branchId,
                                        item.colorId
                                      )}
                                      className="ml-auto p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded"
                                      title={t('buttons.remove')}
                                    >
                                      <TrashIcon />
                                    </button>
                                  </div>
                                </div>
                              </motion.div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>

                    {/* Cart Summary & Actions */}
                    {hasCartItems && (
                      <div className="sticky bottom-0 bg-white border-t border-gray-100 p-6 space-y-4">
                        {/* Coupon Section */}
                        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-100 rounded-xl p-4">
                          <div className="flex items-center justify-between mb-2">
                            <span className="font-semibold text-green-800">
                              {t('cart.haveCoupon')}
                            </span>
                            {currentCoupon ? (
                              <div className="flex items-center gap-2">
                                <span className="text-sm text-green-600 bg-green-100 px-2 py-1 rounded">
                                  {currentCoupon.code}
                                </span>
                                <button
                                  onClick={removeCoupon}
                                  className="text-xs text-red-500 hover:text-red-700"
                                >
                                  {t('cart.removeCoupon')}
                                </button>
                              </div>
                            ) : (
                              <button
                                onClick={openCouponModal}
                                className="text-sm text-green-600 hover:text-green-800 font-medium flex items-center gap-1"
                              >
                                <span>🎫</span>
                                {t('cart.applyCoupon')}
                              </button>
                            )}
                          </div>
                          
                          {couponDiscount && (
                            <div className="space-y-1 text-sm">
                              <div className="flex justify-between">
                                <span className="text-gray-600">{t('cart.discount')}:</span>
                                <span className="font-semibold text-green-600">
                                  -{couponDiscount.discountAmount.toFixed(2)} ج.م
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span className="text-gray-600">{t('cart.savingsPercentage')}:</span>
                                <span className="font-semibold text-green-600">
                                  {couponDiscount.savingsPercentage}%
                                </span>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Summary */}
                        <div className="space-y-2">
                          <div className="flex justify-between items-center">
                            <span className="text-gray-600">
                              {t('cart.subtotal')}
                            </span>
                            <span className="font-semibold">
                              {cartSubtotal.toFixed(2)} ج.م
                            </span>
                          </div>
                          
                          {couponDiscount && (
                            <>
                              <div className="flex justify-between items-center text-green-600">
                                <span>{t('cart.couponDiscount')}:</span>
                                <span className="font-semibold">
                                  -{couponDiscount.discountAmount.toFixed(2)} ج.م
                                </span>
                              </div>
                              <div className="flex justify-between items-center text-green-600">
                                <span>{t('cart.savings')}:</span>
                                <span className="font-semibold">
                                  {couponDiscount.savingsPercentage}%
                                </span>
                              </div>
                            </>
                          )}
                          
                          <div className="border-t pt-2">
                            <div className="flex justify-between items-center">
                              <span className="text-lg font-bold text-gray-900">
                                {t('cart.total')}
                              </span>
                              <span className="text-2xl font-bold text-blue-600">
                                {cartTotal.toFixed(2)} ج.م
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* WhatsApp Button */}
                        <button
                          onClick={handleWhatsAppCheckout}
                          className="w-full py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-medium flex items-center justify-center hover:from-green-600 hover:to-emerald-700 transform hover:-translate-y-0.5 transition-all duration-200 shadow-lg hover:shadow-xl"
                        >
                          <WhatsAppIcon />
                          <span className="ml-2">
                            {t('cart.whatsappOrder')}
                          </span>
                        </button>

                        {/* Action Buttons */}
                        <div className="space-y-3">
                          <button
                            onClick={() => {
                              togglePreview();
                              navigate('/cart');
                            }}
                            className="w-full py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-medium flex items-center justify-center hover:from-blue-700 hover:to-indigo-700 transform hover:-translate-y-0.5 transition-all duration-200 shadow-lg hover:shadow-xl"
                          >
                            <ShoppingCartIcon />
                            <span className="ml-2">
                              {t('cart.viewFullCart')}
                            </span>
                            <ArrowRightIcon />
                          </button>

                          <button
                            onClick={() => {
                              togglePreview();
                              navigate('/checkout');
                            }}
                            className="w-full py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-medium hover:from-purple-700 hover:to-pink-700 transform hover:-translate-y-0.5 transition-all duration-200 shadow-lg hover:shadow-xl"
                          >
                            {t('cart.checkout')}
                          </button>
                        </div>

                        {/* Continue Shopping */}
                        <button
                          onClick={togglePreview}
                          className="w-full text-center text-gray-500 hover:text-gray-700 text-sm transition-colors"
                        >
                          {t('cart.continueShopping')}
                        </button>
                      </div>
                    )}
                  </div>
                </motion.div>
              </>
            )}
          </AnimatePresence>

          {/* Coupon Modal */}
          <AnimatePresence>
            {isCouponModalOpen && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
                onClick={closeCouponModal}
              >
                <motion.div
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.9, opacity: 0 }}
                  className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-bold text-gray-900">
                      {t('cart.couponQuestion')}
                    </h3>
                    <button
                      onClick={closeCouponModal}
                      className="p-2 hover:bg-gray-100 rounded-lg"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                  
                  <p className="text-gray-600 mb-6">
                    {t('cart.enterCouponBelow')}
                  </p>
                  
                  <div className="space-y-4">
                    <div>
                      <input
                        type="text"
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value)}
                        placeholder={t('cart.enterCouponCode')}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      />
                    </div>
                    
                    <div className="flex gap-3">
                      <button
                        onClick={() => handleCouponValidation(couponCode)}
                        disabled={isValidatingCoupon || !couponCode.trim()}
                        className="flex-1 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl font-medium hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                      >
                        {isValidatingCoupon ? t('cart.applying') : t('cart.validate')}
                      </button>
                      
                      <button
                        onClick={() => {
                          closeCouponModal();
                          openDeliveryModal();
                        }}
                        className="flex-1 py-3 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-xl font-medium hover:from-gray-700 hover:to-gray-800 transition-all"
                      >
                        {t('cart.withoutCoupon')}
                      </button>
                    </div>
                    
                    <p className="text-sm text-gray-500 text-center">
                      {t('cart.whatsappNotice')}
                    </p>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Delivery Information Modal */}
          <AnimatePresence>
            {isDeliveryModalOpen && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
                onClick={closeDeliveryModal}
              >
                <motion.div
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.9, opacity: 0 }}
                  className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-6">
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">
                          🏠 معلومات التوصيل
                        </h3>
                        <p className="text-gray-600 text-sm mt-1">
                          أدخل معلومات المدينة لتسليم طلبك
                        </p>
                      </div>
                      <button
                        onClick={closeDeliveryModal}
                        className="p-2 hover:bg-gray-100 rounded-lg"
                      >
                        <CloseIcon />
                      </button>
                    </div>

                    <div className="space-y-4">
                      {/* City - إلزامي */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          المدينة * {t('checkout.city')}
                        </label>
                        <input
                          type="text"
                          value={cityName}
                          onChange={(e) => setCityName(e.target.value)}
                          placeholder="مثال: القاهرة، الجيزة، الإسكندرية"
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                          required
                        />
                      </div>

                      {/* District - اختياري */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          الحي/المنطقة (اختياري)
                        </label>
                        <input
                          type="text"
                          value={districtName}
                          onChange={(e) => setDistrictName(e.target.value)}
                          placeholder="مثال: المهندسين، مدينة نصر، المعادي"
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                        />
                      </div>


                      {/* Order Summary Preview */}
                      <div className="bg-gray-50 rounded-xl p-4 mt-4">
                        <h4 className="font-semibold text-gray-800 mb-2">
                          ملخص الطلب:
                        </h4>
                        <div className="space-y-1 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">عدد المنتجات:</span>
                            <span className="font-medium">{cartCount}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">المجموع:</span>
                            <span className="font-medium text-green-600">
                              {cartTotal.toFixed(2)} ج.م
                            </span>
                          </div>
                          {currentCoupon && (
                            <div className="flex justify-between text-green-600">
                              <span>الكوبون المطبق:</span>
                              <span className="font-medium">{currentCoupon.code}</span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="flex gap-3 pt-4">
                        <button
                          onClick={startRedirectCountdown}
                          disabled={!cityName.trim()}
                          className="flex-1 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl font-medium hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                        >
                          <WhatsAppIcon />
                          {t('cart.confirmOrder')}
                        </button>
                        
                        <button
                          onClick={closeDeliveryModal}
                          className="px-6 py-3 bg-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-300 transition-all"
                        >
                          {t('common.cancel')}
                        </button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Redirecting Countdown Modal */}
          <AnimatePresence>
            {isRedirecting && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4"
              >
                <motion.div
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.9, opacity: 0 }}
                  className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center"
                >
                  <div className="mb-6">
                    <div className="w-20 h-20 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4">
                      <motion.div
                        animate={{ rotate: 360 }}
                        transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                      >
                        <WhatsAppIcon />
                      </motion.div>
                    </div>
                    
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      جاري فتح واتساب...
                    </h3>
                    
                    <div className="text-5xl font-bold text-green-600 my-6">
                      {countdown}
                    </div>
                    
                    <p className="text-gray-600 mb-4">
                      سيتم فتح محادثة واتساب تلقائياً خلال {countdown} ثانية
                    </p>
                    
                    <div className="bg-gray-50 rounded-xl p-4">
                      <p className="text-sm text-gray-600">
                        🛒 المنتجات: {cartCount}
                        <br />
                        💰 الإجمالي: {cartTotal.toFixed(2)} ج.م
                        <br />
                        🏠 المدينة: {cityName}
                        {districtName && ` - ${districtName}`}
                        {currentCoupon && `\n🎫 الكوبون: ${currentCoupon.code}`}
                      </p>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => {
                      setIsRedirecting(false);
                      openWhatsAppDirectly();
                    }}
                    className="w-full py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl font-medium hover:from-green-700 hover:to-emerald-700 transition-all"
                  >
                    فتح واتساب الآن
                  </button>
                  
                  <button
                    onClick={() => setIsRedirecting(false)}
                    className="w-full mt-3 text-gray-500 hover:text-gray-700"
                  >
                    إلغاء
                  </button>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Generic Modal */}
          <GenericModal />
          
          {/* Footer */}
          <Footer />
        </div>
      </GenericModalProvider>
    </NotificationProvider>
  );
};

export default Layout;